// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import 'owl.carousel2/dist/owl.carousel.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import reservationDeSalle from './routes/reservation_de_salle';
import toplevelPageSalles from './routes/gestion_salle';
import home from './routes/home';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas, far, fal, fab);
dom.i2svg();

var sallesPageReservationDeSalle = reservationDeSalle;

/** Populate Router instance with DOM routes */
const routes = new Router({
  reservationDeSalle,
  sallesPageReservationDeSalle,
  toplevelPageSalles,
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js